import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../Context/UserContextAPI";
const IconGroupInHomePage = () => {
  // context

  const { accessPerm } = useContext(UserContext);

  const [smsBalance, setSMSBalance] = useState(0);

  const removeHtmlTags = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  };

  const bioChemistryUrl = process.env.REACT_APP_BIOCHEMISTRY_URL;
  const photoUrl = process.env.REACT_APP_PHOTO_URL;
  const qcPassedUrl = process.env.REACT_APP_QC_PASSED_URL;

  const iconGroupData = [
    {
      id: 1,
      title: "Registration",
      link: "/dashboard/patient-info/create",
      accessPerm: accessPerm(32, 1),
      image: "/img/registration.png",
    },
    {
      id: 2,
      title: "Collection",
      link: "/dashboard/specimen-collection",
      accessPerm: accessPerm(35, 4),
      image: "/img/collection.png",
    },
    {
      id: 3,
      title: "Medical Results",
      link: "/dashboard/medical-reports",
      accessPerm: accessPerm(33, 4),
      image: "/img/medical-report.png",
    },
    {
      id: 4,
      title: "Registration Report",
      link: "/dashboard/medical-registration",
      accessPerm: accessPerm(67, 4),
      image: "/img/report-registration.png",
    },
    {
      id: 5,
      title: "Result Report",
      link: "/dashboard/result",
      accessPerm: accessPerm(68, 4),
      image: "/img/medical-result.png",
    },
    {
      id: 6,
      title: "Fit Patient",
      link: "/dashboard/fit-patients",
      accessPerm: accessPerm(49, 4),
      image: "/img/fit.png",
    },
    {
      id: 7,
      title: "Unfit Patient",
      link: "/dashboard/unfit-patients",
      accessPerm: accessPerm(50, 4),
      image: "/img/unfit.png",
    },
    {
      id: 8,
      title: "Heldup Patient",
      link: "/dashboard/held-up-patients",
      accessPerm: accessPerm(51, 4),
      image: "/img/heldup.png",
    },
    {
      id: 9,
      title: "Photo",
      link: photoUrl,
      accessPerm: true,
      image: "/img/camera.png",
      isNewTab: true,
    },
    {
      id: 10,
      title: "QC Passed",
      link: qcPassedUrl,
      accessPerm: accessPerm(33, 14),
      image: "/img/qc_icon.png",
      isNewTab: true,
    },
  ];

  return (
    <div className="p-3 d-flex flex-wrap gap-2">
      <div className="d-flex justify-content-start">
        {accessPerm(75, 4) && (
          <div
            className="card d-flex flex-column border"
            style={{ width: "180px", height: "160px" }}
          >
            <div
              className="row flex-grow-1"
              style={{ backgroundColor: "#cce3c1", height: "90px" }}
            >
              <div className="col d-flex align-items-center justify-content-center">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="text-center text-dark fs-6">
                    <div className="fw-bold">
                      Tk. {removeHtmlTags(smsBalance || 0)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="row"
              style={{ height: "50px", backgroundColor: "#000000" }}
            >
              <div className="col d-flex align-items-center justify-content-center">
                <div className="d-flex align-items-center justify-content-center">
                  <div className="text-center text-dark">
                    <div className="fw-bold text-white">SMS Balance</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {iconGroupData.map((item) => {
        if (!item.accessPerm) {
          return null;
        }
        return (
          <div className="d-flex justify-content-start">
            <Link
              to={item.link}
              target={item.isNewTab ? "_blank" : "_self"}
              style={{ textDecoration: "none" }}
            >
              <div
                className="card d-flex flex-column border"
                style={{
                  width: "180px",
                  height: "160px",
                  cursor: "pointer",
                  border: "1px solid transparent",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 8px rgba(0, 0, 0, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div className="row flex-grow-1" style={{ height: "90px" }}>
                  <div className="col d-flex align-items-center justify-content-center">
                    <div className="d-flex align-items-center justify-content-center">
                      <img
                        src={item.image}
                        alt=""
                        style={{ height: "100px", width: "100px" }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="row"
                  style={{ height: "50px", backgroundColor: "#000000" }}
                >
                  <div className="col d-flex align-items-center justify-content-center">
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="text-center text-dark">
                        <div className="fw-bold text-white">{item.title}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
};
export default IconGroupInHomePage;
